import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MoveMoneyContext } from '../../context/MoveMoneyContext';
import '../MoveMoney/MoveMoney.css';
import { validateAmount } from '../../api';

const Amount = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const moveMoneyContext = useContext(MoveMoneyContext);

  if (!moveMoneyContext) {
    throw new Error('MoveMoneyContext must be used within a MoveMoneyProvider');
  }

  const { amount, setAmount } = moveMoneyContext;

  const handleNext = async () => {
    setIsLoading(true);
    const { success } = await validateAmount(amount);
    setIsLoading(false);
    if (success) {
      navigate('/move-money/select-account');
    } else {
      alert('Please enter a valid amount.');
    }
  };

  const handleBack = () => {
    navigate('/move-money');
  };

  return (
    <div className="flow-step">
      <h2 className="step-header">Enter Amount</h2>
      <input
        type="number"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        placeholder="0.00"
      />
      <div className="navigation-buttons">
        <button onClick={handleBack} disabled={isLoading}>Back</button>
        <button onClick={handleNext} disabled={isLoading}>
          {isLoading ? 'Validating...' : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default Amount;
